import MentoringSuccess from './MentoringSuccess.vue';

export default MentoringSuccess;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/succss/index.ts